import { useState } from "react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import { useNavigate } from "react-router-dom";
import SessionStorageHelper from "../../utils/sessionStorageHelper";
import { Activity } from "lucide-react";

interface RaceData {
  race: string;
}

interface RacepageProps {
  onSubmit?: (data: RaceData) => void;
}

const Racepage = ({ onSubmit }: RacepageProps) => {
  const [selected, setSelected] = useState<string>("");
  const navigate = useNavigate();

  const handleSave = () => {
    if (selected) {
      SessionStorageHelper.saveField("race", selected);
      SessionStorageHelper.debugPrintData();

      if (onSubmit) {
        onSubmit({ race: selected });
      }

      navigate("/glucera" + GluceraNavigationRoutes.AGE_PAGE);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const raceOptions = [
    { display: "White", value: "white" },
    { display: "Black or African American", value: "black_african_american" },
    { display: "Asian", value: "asian" },
    {
      display: "American Indian or Alaska Native",
      value: "american_indian_alaska_native",
    },
    {
      display: "Native Hawaiian/Pacific Islander",
      value: "native_hawaiian_pacific_islander",
    },
    {
      display: "Middle Eastern or North African",
      value: "middle_eastern_north_african",
    },
    { display: "Other", value: "other" },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header with Progress */}
        <div className="space-y-4 p-4">
          {/* <button
            onClick={handleBack}
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-muted/80 transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button> */}

          {/* Logo */}
          <div className="flex items-center justify-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-orange-400">
              <Activity className="h-5 w-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-slate-500">
              Bite Balance
            </span>
          </div>

          {/* Assessment Progress */}
          <p className="text-center text-sm text-muted-foreground">
            Assessment 2 of 12
          </p>
        </div>

        {/* Content - Scrollable */}
        <div className="flex-1 overflow-y-auto px-6 py-2">
          <div className="mb-4 space-y-2">
            <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
              What Is Your Race
            </h1>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Race Helps In Identifying Appropriate Treatment As Diabetes
              Management Can Vary By Your Race.
            </p>
          </div>

          <div className="space-y-3 pb-4">
            {raceOptions.map(option => (
              <Card
                key={option.value}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selected === option.value
                    ? "border-2 border-primary bg-primary/5"
                    : "border-2 border-border hover:border-primary/50"
                }`}
                onClick={() => setSelected(option.value)}
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="text-base font-semibold leading-tight">
                    {option.display}
                  </span>
                  <div
                    className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border-2 ${
                      selected === option.value
                        ? "border-primary bg-primary"
                        : "border-muted-foreground"
                    }`}
                  >
                    {selected === option.value && (
                      <div className="h-3 w-3 rounded-full bg-primary-foreground" />
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Footer Button */}
        <div className="pb-safe border-t p-4">
          <Button
            onClick={handleSave}
            disabled={!selected}
            className="h-11 w-full rounded-xl bg-gradient-primary text-sm hover:opacity-90 disabled:opacity-50 sm:h-12 sm:text-base"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Racepage;
